import EventEmitter from './EventEmitter.js';

export default class Sizes extends EventEmitter
{
    // Set constructor
    constructor(canvas)
    {
        // Extends the EventEmitter class
        super();

        // Get the canvas size
        this.canvasWidth = canvas.offsetWidth;
        this.canvasHeight = canvas.offsetHeight;

        // Get canvas margin
        let rect = canvas.getBoundingClientRect();
        // Get canvas sizes and pixel ratio
        this.width = rect.width;
        this.height = rect.height;
        this.pixelRatio = Math.min(window.devicePixelRatio, 2);

        // Get the scroll difference
        const scrollX = window.scrollX || document.documentElement.scrollLeft;
        const scrollY = window.scrollY || document.documentElement.scrollTop;
        // Get the aim and set it to the middle of the canvas
        this.aim = document.getElementById('firts-person-aim');
        this.aim.style.top = rect.top + scrollY + this.height / 2 + 'px';
        this.aim.style.left = rect.left + scrollX + this.width / 2 + 'px';
    }

    // Resize event handler
    resizeHandler(canvas)
    {
        // Get canvas margin
        let rect = canvas.getBoundingClientRect();

        // If the canvas sizes changed
        if((this.width !== rect.width) || (this.height !== rect.height))
        {
            // Get new canvas sizes and pixel ratio
            this.width = rect.width;
            this.height = rect.height;
            this.pixelRatio = Math.min(window.devicePixelRatio, 2);

            // Get the scroll difference
            const scrollX = window.scrollX || document.documentElement.scrollLeft;
            const scrollY = window.scrollY || document.documentElement.scrollTop;
            // Get the aim and set it to the middle of the canvas
            this.aim.style.top = rect.top + scrollY + this.height / 2 + 'px';
            this.aim.style.left = rect.left + scrollX + this.width / 2 + 'px';
            
            // Trigger resize event
            this.trigger('resize');
        }
    }

    // Method propagated by the experience to destroy this instance and their listeners
    destroy()
    {
        // Reset variables
        this.width = null;
        this.height = null;
        this.pixelRatio = null;
        this.aim = null;
    }
}